// extracted by mini-css-extract-plugin
export default {"currentTimeIndicator":"_2lkHqjkK","circularPart":"PjAzbiId","linePart":"N3bLT8vl"};